export const enumServerBackup = {
  None: 0,
  Commvault: 1,
  Guardian: 2
};
